/**
 * streamlines add a dynamic value to padding.
 * @param {object} param0
 * @param {number|string} param0.$padding
 * @returns {string}
 */
const dynPadding = ({ $padding }) => {
  if ($padding === undefined) return "";
  if (typeof $padding === "number") return `padding: ${$padding}px;`;
  return `padding: ${$padding};`;
};

export default dynPadding;
